/* eslint-disable no-nested-ternary */
/* eslint-disable no-underscore-dangle */
import {
  Dialog, DialogContent, DialogTitle, Hidden,
} from "@material-ui/core";
import React from "react";
import CloseIcon from "@material-ui/icons/Close";
import moment from "moment";
import { ThemeActionButton } from "../../widgets";
import { capitalize } from "../../methods/sharedMethods";
import { DaysIncluded, ModeAndPercentage } from "../../../Constant";

const renderContractAndUnit = (raw, contractDetail) => {
  let renderContractType = null;
  let renderRawUnit = null;
  if (raw.contractType) {
    renderContractType = (
      <div className="detailrow">
        <div>Contract Type</div>
        {" "}
        <div>{contractDetail[raw.contractType]}</div>
      </div>
    );
  }
  if (raw.unit) {
    renderRawUnit = (
      <div className="detailrow">
        <div>Criteria</div>
        {" "}
        <div>{contractDetail[raw.unit]}</div>
      </div>
    );
  }
  return (
    <>
      {renderContractType}
      {renderRawUnit}
    </>
  );
};

const renderUnitDetailsAndFlatFeeCriteria = (raw) => {
  let renderRawUnit = null;
  let renderFlatFeeCriteria = null;
  if (raw.unit === "perDay") {
    renderRawUnit = (
      <div className="detailrow">
        <div>Amount</div>
        <div>{raw.dayWisePaidAmount}</div>
      </div>
    );
  } else if (raw.unit === "perKm") {
    renderRawUnit = (
      <div className="detailrow">
        <div>Earning</div>
        <div>{raw.kmWisePaidAmount}</div>
      </div>
    );
  }
  if (raw.flatFeeCriteria) {
    const isPrepaid = raw?.billingType && raw?.billingType === "prepaid";
    renderFlatFeeCriteria = (
      <div className="detailrow">
        <div>Criteria</div>
        <div>
          {raw.flatFeeCriteria === "perMonth" ? "Per Month" : "Per Day"}
          <span className="font-weight-400">{isPrepaid && " (Prepaid)"}</span>
        </div>
      </div>
    );
  }

  return (
    <>
      {renderRawUnit}
      {renderFlatFeeCriteria}
    </>
  );
};

const renderBaselineAndRawCriteriaDetail = (raw, componentType, contractDetail) => {
  let baselineCriteriaDetail = null;
  let rawCriteriaDetail = null;
  if (componentType === "vehicle" && raw.baselineCriteria) {
    baselineCriteriaDetail = (
      <div className="detailrow">
        <div>Criteria</div>
        {" "}
        <div>{contractDetail[raw.baselineCriteria]}</div>
      </div>
    );
  }
  if (raw.criteria) {
    rawCriteriaDetail = (
      <div className="detailrow">
        <div>Criteria</div>
        {" "}
        <div>{contractDetail[raw.criteria]}</div>
      </div>
    );
  }
  return (
    <>
      {baselineCriteriaDetail}
      {rawCriteriaDetail}
    </>
  );
};

const renderFlatFeeOnDetails = (raw, detail) => {
  if (raw.flatFeeCriteria) {
    return (
      <>
        <div className="detailrow">
          <div>Flat Fee On</div>
          {" "}
          <div>{raw.flatFeeOn === "perRide" ? "Per Ride" : "Per Bus"}</div>
        </div>
        {raw.flatFeeOn === "perRide"
          && (
            <div className="detailrow">
              <div>Minimum Rides</div>
              {" "}
              <div>{raw.minimumRides}</div>
            </div>
          )}
        {raw.flatFeeOn === "perBus" && (
          <>
            <div className="detailrow">
              <div>Subscription Plan</div>
              {" "}
              <div>{detail?.subscription?.planName}</div>
            </div>
            <div className="detailrow">
              <div>Add Ons</div>
              {" "}
              <div>
                {detail?.subscription?.addOns
                  ?.map((addOn) => addOn.name)
                  .join(", ")}
              </div>
            </div>
          </>
        )}
        <div className="detailrow">
          <div>Flat Fee</div>
          {" "}
          <div>{raw.flatFee}</div>
        </div>
        <div className="detailrow">
          <div>Days included</div>
          {" "}
          <div>{DaysIncluded[raw.daysToInclude] || "Waybill Days"}</div>
        </div>
      </>
    );
  }
  return null;
};

const renderModePercentagePerTicketAndBaselineDetail = (raw, componentType, contractDetail) => {
  let modeAndPercentageDetail = null;
  let perTicketDetail = null;
  let baselinePercentageDetail = null;
  if (raw?.modeAndPercentage?.length) {
    modeAndPercentageDetail = (
      <div>
        <div className="detailrow">
          <div>Collection Type</div>
          {" "}
          <div>
            {componentType === "vehicle"
              ? contractDetail[raw.modeAndPercentage[0].percentageCriteria]
              : raw.modeAndPercentage[0].percentageCriteria}
          </div>
        </div>
        <div className="detailrow">
          <div>Percentage</div>
          {" "}
          {raw.modeAndPercentage[0].percentageCriteria !== "mobileDigitalCollection" && raw.modeAndPercentage[0].percentageCriteria !== "cardDigitalCollection"
            ? <div>{raw.modeAndPercentage[0].percentage}</div>
            : (
              <div className="flex">
                {
                  raw.modeAndPercentage.map(({ percentageCriteria, percentage }) => (
                    <div key={percentageCriteria}>
                      <div>{`${ModeAndPercentage[percentageCriteria]} - ${percentage} %`}</div>
                    </div>
                  ))
                }
              </div>
            )}
        </div>
      </div>
    );
  }
  if (raw?.perTicketBased?.length) {
    perTicketDetail = (
      <div>
        <div className="detailrow">
          <div>Ticket Type</div>
          {" "}
          <div>{contractDetail[raw.perTicketBased[0].ticketCountType]}</div>
        </div>
        <div className="detailrow">
          <div>Fee</div>
          {" "}
          <div>{raw.perTicketBased[0].fee}</div>
        </div>
      </div>
    );
  }
  if (raw.baselinePercentage?.length > 0) {
    baselinePercentageDetail = raw.baselinePercentage.map((One) => (
      <div key={One.baseline}>
        {componentType === "vehicle" ? (
          <>
            <div className="detailrow">
              <div>Baseline</div>
              {" "}
              <div>{One.baseline}</div>
            </div>
            {One?.percentageCriteria && (
              <div className="detailrow">
                <div>Collection Type</div>
                {" "}
                <div>{contractDetail[One.percentageCriteria]}</div>
              </div>
            )}
            {raw?.baselineCriteria === "flatFeeBased" && (
              <div className="detailrow">
                <div>Flat Fee</div>
                {" "}
                <div>{One.baselineFlatFee}</div>
              </div>
            )}
            {raw?.baselineCriteria !== "flatFeeBased" && (
              <div className="detailrow">
                <div>Percentage</div>
                {" "}
                <div>{One.percentage}</div>
              </div>
            )}
          </>
        ) : (
          <div className="detailrow">
            <div>Percentage</div>
            {" "}
            <div>{One.percentage}</div>
          </div>
        )}
      </div>
    ));
  }
  return (
    <>
      {modeAndPercentageDetail}
      {perTicketDetail}
      {baselinePercentageDetail}
    </>
  );
};

const renderThresholdAndCappingDetail = (raw) => {
  let renderThresholdDetail = null;
  let renderCappingDetail = null;
  if (raw.is_threshold) {
    renderThresholdDetail = (
      <>
        {raw.unit === "perDay" && (
          <div className="detailrow">
            <div>EPKM (Rs.) - Distance (KM)</div>
            <div>
              {raw.epkmBG}
              {" "}
              -
              {raw.travelKmBG}
            </div>
          </div>
        )}
        {raw.unit === "perKm" && (
          <div className="detailrow">
            <div>Threshold Kilometer</div>
            <div>{raw.kmWiseThreshold}</div>
          </div>
        )}
        <div className="detailrow">
          <div>Penalty</div>
          {" "}
          <div>{raw.penalty || 0}</div>
        </div>
      </>
    );
  }
  if (raw.is_capping) {
    renderCappingDetail = (
      <div className="detailrow">
        <div>Max Loss</div>
        {" "}
        <div>{raw.cappingAmount}</div>
      </div>
    );
  }
  return (
    <>
      {renderThresholdDetail}
      {renderCappingDetail}
    </>
  );
};

const renderExpensesDetail = (detail, getExpenseDisplayName) => {
  if (detail?.expenses?.length) {
    return (
      <div>
        <div className="sub-heading">
          <span>Expenses</span>
        </div>
        <div className="sub-container">
          {detail.expenses.map((expense, index) => (
            <div className="detailrow" key={index}>
              <div>{getExpenseDisplayName(expense.type)}</div>
              {" "}
              <div>
                {expense.amount ? expense.amount : expense.percentage}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
  return null;
};

function ContractModal(props) {
  const {
    state,
    closeDetailModal,
    contractHandler,
    openConfirmationModal,
    openRenewConfirmationModal,
    getExpenseDisplayName,
    contractDetail,
    componentType = "vehicle",
  } = props;
  const { contractDetails: detail } = state;

  return (
    <Dialog
      onClose={closeDetailModal}
      aria-labelledby="customized-dialog-title"
      open={state.showDetailModal}
      className="dialogWrapper"
    >
      <DialogTitle id="customized-dialog-title" onClose={closeDetailModal}>
        <div className="modalHeaderWrapper">
          <Hidden only={["sm", "xs"]}>
            <div className="dialogTitle">Contract Details</div>
            <div className="dialogTitle">{`Vehicle - ${detail.busNumber}`}</div>
          </Hidden>
          <Hidden only={["lg", "xl", "md"]}>
            <div className="dialogTitle">{`${detail.busNumber} Details`}</div>
          </Hidden>
          <div className="btnWrapper">
            {componentType === "vehicle" && (
              <Hidden only={["sm", "xs"]}>
                <div className="closeIcon">
                  {detail.status.toLowerCase() === "active" && (
                    <ThemeActionButton
                      onClick={() => contractHandler(detail, "edit")}
                      buttonText="Edit Contract"
                    />
                  )}
                  {(detail.status.toLowerCase() === "active"
                    || detail.status.toLowerCase() === "upcoming")
                    && (
                      <ThemeActionButton
                        onClick={() => openConfirmationModal(detail._id)}
                        buttonText="Terminate"
                      />
                    )}
                </div>
                {detail.is_renewable && (
                  <div className="closeIcon">
                    <ThemeActionButton
                      onClick={() => openRenewConfirmationModal(detail)}
                      buttonText="Renew"
                    />
                  </div>
                )}
              </Hidden>
            )}
            <div
              className="closeIcon"
              role="button"
              onClick={closeDetailModal}
              onKeyDown={(e) => {
                if (e.key === "Escape") {
                  closeDetailModal();
                }
              }}
              tabIndex="0"
              aria-label="close"
            >
              <CloseIcon />
            </div>
          </div>
        </div>
      </DialogTitle>
      <DialogContent dividers className="detailWrapper">
        <div className="sub-heading">
          <span>Terms</span>
        </div>
        <div className="sub-container">
          <div className="detailrow">
            <div>Period</div>
            {" "}
            <div>
              {`${moment(detail.fromDate).format("DD MMM YYYY")} - ${moment(
                detail.toDate,
              ).format("DD MMM YYYY")}`}
              <span
                className={
                  detail.status === "Expired" ? "expiredStyle" : "activeStyle"
                }
              >
                {detail.status}
              </span>
            </div>
          </div>
          <div className="detailrow">
            <div>Collection Handled By</div>
            {" "}
            <div>{capitalize(detail.borneBy)}</div>
          </div>
        </div>
        {detail?.businessDeals?.length > 0
          && detail.businessDeals.map((raw) => (
            <div key={raw.unit}>
              <div className="sub-heading">
                <span>Commercials</span>
              </div>
              <div className="sub-container">
                {renderContractAndUnit(raw, contractDetail)}
                {renderUnitDetailsAndFlatFeeCriteria(raw)}
                {renderBaselineAndRawCriteriaDetail(raw, componentType, contractDetail)}
                {renderFlatFeeOnDetails(raw, detail)}
                {renderModePercentagePerTicketAndBaselineDetail(raw, componentType, contractDetail)}
                {renderThresholdAndCappingDetail(raw)}
              </div>
            </div>
          ))}
        {renderExpensesDetail(detail, getExpenseDisplayName)}
      </DialogContent>
    </Dialog>
  );
}

export default ContractModal;
